import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaHardHat, FaMapMarkerAlt, FaMountain, FaRoad } from 'react-icons/fa';
import './Projects.css';

const featuredProjects = [
  {
    number: '01',
    title: 'Tunnel Work',
    partner: 'Bilwadams (Nig.) Limited',
    location: 'Isiagu, Ebonyi State',
    description: 'A special construction and engineering project involving tunnel excavation and related activities, delivered in partnership with Bilwadams (Nig.) Limited.'
  },
  {
    number: '02',
    title: 'Contour Line Blasting',
    partner: 'Aso Rock Villa',
    location: 'Abuja, FCT',
    description: 'Precision contour line blasting carried out within the Aso Rock Villa environment with careful attention to control, safety, and site protection.'
  },
  {
    number: '03',
    title: 'Tower Base Hole Works',
    partner: 'Energo Nig. Ltd',
    location: 'Abuja - Shiroro Dam',
    description: 'Specialized tower base hole works supporting infrastructure development along the Abuja - Shiroro Dam corridor.'
  },
  {
    number: '04',
    title: 'Road Works',
    partner: 'Zerock Nig. Ltd',
    location: 'Nasarawa / Kogi State',
    description: 'Engineering support for road works across challenging terrain, combining drilling, blasting, and coordinated site operations.'
  }
];

const nationwideExperience = [
  ['Tunnel Work', 'Bilwadams (Nig.) Limited', 'Isiagu, Ebonyi State'],
  ['Contour Line Blasting', 'Aso Rock Villa', 'Abuja'],
  ['Tower Base Hole Works', 'Energo Nig. Ltd', 'Abuja - Shiroro Dam'],
  ['Road Work', 'Zerock Nig. Ltd', 'Nasarawa / Kogi State'],
  ['Quarry Work', 'Stateco Nig. Ltd', 'Nigeria'],
  ['Special Drilling & Blasting Works', 'Ital Systems Nig. Ltd', 'Abuja'],
  ['Drainage Blasting Works', 'Independent project', 'Jalingo, Taraba State'],
  ['Drainage System', 'Urban Shelters', 'Abuja'],
  ['Quarry Rocks & Management', 'Calstone Properties', 'Nigeria'],
  ['Railway Dualization Project', 'C.C.E.C.C', 'Abuja'],
  ['Substation Tower Base Hole', 'PHCH-MBH', 'Abuja'],
  ['Rock Outcrop Blasting', 'Churchgate FCPL', 'World Trade Center, Abuja'],
  ['Plot Reclamation', 'Ministers Hill', 'Abuja'],
  ['Rock Drilling and Blasting', 'FAFU Estate', 'Abuja'],
  ['Land Reclamation and Service Lines', 'Brains & Hammers', 'Galadima, Apo and Life Camp'],
  ['Road Construction and Site Services', 'Nigerian Air Force - NAF Valley Estate', 'Abuja'],
  ['Special Project', 'Nigerian Army Special Project (NASP)', 'Asokoro, Abuja'],
  ['Estate Road Construction', 'Sow Estate', 'Katampe Extension'],
  ['Estate Development', 'Cosgrove Estate', 'Gishiri, Abuja'],
  ['Hydro Way Works', 'Skipper - Chalawa Dam', 'Kano State'],
  ['Quarry Operations', 'Eksiogullari Quarry', 'Kaduna State'],
  ['Lead Mining', 'Lead Mining Mavo', 'Plateau State']
];

function Projects() {
  return (
    <main className="projects-page">
      <section className="projects-hero">
        <div className="projects-hero-lines"></div>
        <div className="container projects-hero-content">
          <p className="projects-kicker">A decade of getting difficult work done</p>
          <h1>Projects that stand<br /><em>on solid ground.</em></h1>
          <p className="projects-intro">Our experience in drilling and blasting in Nigeria cannot be overemphasized. Here are some of the major jobs and activities carried out over the last ten years.</p>
          <Link to="/contact" className="projects-hero-link">Discuss your project <FaArrowRight /></Link>
        </div>
        <div className="projects-hero-mark">CUF <span>/ 10</span></div>
      </section>

      <section className="projects-featured section">
        <div className="container">
          <div className="projects-section-heading">
            <div>
              <p className="section-label">01 / Selected work</p>
              <h2>Top 4 world projects</h2>
            </div>
            <p>Four examples of the precision, site discipline, and engineering judgment we bring to complex work.</p>
          </div>
          <div className="featured-projects-grid">
            {featuredProjects.map(project => (
              <article className="featured-project" key={project.number}>
                <div className="project-number">{project.number}</div>
                <div className="project-icon"><FaMountain /></div>
                <p className="project-location"><FaMapMarkerAlt /> {project.location}</p>
                <h3>{project.title}</h3>
                <strong>{project.partner}</strong>
                <p>{project.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="projects-world section">
        <div className="container">
          <div className="world-heading">
            <p className="section-label">02 / Across the map</p>
            <h2>Projects from<br /><em>four sides of the world.</em></h2>
            <p>Our work spans construction, infrastructure, estate development, quarry operations, and mining support across Nigeria.</p>
          </div>
          <div className="world-stats">
            <div><FaHardHat /><strong>10+</strong><span>Years of experience</span></div>
            <div><FaRoad /><strong>22</strong><span>Major activities listed</span></div>
            <div><FaMapMarkerAlt /><strong>12+</strong><span>States and territories</span></div>
          </div>
        </div>
      </section>

      <section className="experience-section section">
        <div className="container">
          <div className="projects-section-heading experience-heading">
            <div>
              <p className="section-label">03 / Nationwide job experience</p>
              <h2>A record built<br />across the country.</h2>
            </div>
            <p>Below are some of the major jobs and activities carried out in the last ten years, including companies we have worked for.</p>
          </div>
          <div className="experience-list">
            {nationwideExperience.map(([job, company, location], index) => (
              <div className="experience-item" key={`${job}-${company}`}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                <FaHardHat />
                <div><h3>{job}</h3><p>{company}</p></div>
                <p className="experience-location"><FaMapMarkerAlt /> {location}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="projects-cta">
        <div className="container">
          <p className="section-label">04 / Your next project</p>
          <h2>Our idea grows<br /><em>from your imagination.</em></h2>
          <p>Get it out and let us know. We are ready to help turn your next challenge into measurable progress.</p>
          <Link to="/contact" className="btn btn-primary">Contact us <FaArrowRight /></Link>
        </div>
      </section>
    </main>
  );
}

export default Projects;
